"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultTextValue = exports.useTextField = void 0;

var _useFormField = require("./useFormField");

/**
 * @param  args { import("../useForm").IFormFieldArgs}
 */
var useTextField = function useTextField(state, dispatch) {
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return (0, _useFormField.useFormField)(state, dispatch, args);
};

exports.useTextField = useTextField;
var defaultTextValue = '';
exports.defaultTextValue = defaultTextValue;